export const PROVIDER_CANVAS = "canvas";
export const PROVIDER_ONE_ROSTER = "one_roster";
export const PROVIDER_CLEVER = "clever";
export const PROVIDER_CLASSLINK = "classlink";

export const INTEGRATION_PROVIDERS = {
  0: PROVIDER_CANVAS,
  1: PROVIDER_ONE_ROSTER,
  2: PROVIDER_CLEVER,
  3: PROVIDER_CLASSLINK,
};

export const INTEGRATION_PROVIDER_NAME_TO_TYPE = Object.fromEntries(
  Object.entries(INTEGRATION_PROVIDERS).map(([key, value]) => [
    value,
    Number(key),
  ]),
);

export const staticConnectionProviderNames = [
  PROVIDER_CLEVER,
  PROVIDER_CLASSLINK,
];
export const staticConnectionProviderTypes = staticConnectionProviderNames.map(
  (name) => INTEGRATION_PROVIDER_NAME_TO_TYPE[name],
);

export const staticConnectionIds = [
  process.env.CLASSLINK_CONNECTION_ID,
  process.env.CLEVER_CONNECTION_ID,
];

export const Status = {
  SUCCESS: "success",
  PARTIAL: "partial",
  FAILED: "failed",
  RUNNING: "running",
  OFFLINE: "offline",
};
